// extracted by mini-css-extract-plugin
module.exports = {"message":"gJES_A","message-content":"_1qtBXx"};